export default function Switch(theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          // Color of the thumb when OFF
          color: theme.palette.grey[500],
          '&.Mui-checked': {
            // Color of the thumb when ON
            color: theme.palette.primary.darker,
            '& + .MuiSwitch-track': {
              // Color of the track when ON
              backgroundColor: theme.palette.primary.darker,
              opacity: 0.5, // Standard MUI opacity for tracks
            },
          },
        },
        track: {
          // Color of the track when OFF
          backgroundColor: theme.palette.grey[400],
          opacity: 1,
        },
      },
    },
  };
}